import React, {Component} from "react";
import Img from "../../../common/Img";

class ResultStudentInfoHeader extends Component {
    state = {
        student: {},
        counter: 0,
    };

    renderWidget = (label, value) => {
        return (
            <div className="white-background-with-border result-summary-widget" style={{
                height: "100%",
                display: "grid",
                gridTemplateRows: "calc(100% / 2) 1px calc(100% / 2)",
                textAlign: "center",
            }}>
                <div style={{
                    display: "flex",
                    placeItems: "center center"
                }}>
                    <p style={{width: "100%", color: "var(--blue)"}}>{label}</p>
                </div>

                <hr style={{
                    border: "none",
                    background: "#c1c1c1",
                    height: "2px",
                }}/>

                <div style={{
                    display: "flex",
                    placeItems: "center right"
                }}>
                    <p style={{width: "100%"}}>{value}</p>
                </div>
            </div>
        )
    }

    renderIdentityField = (label, value, extraClass = "") => {
        return (
            <div className={`result-identity-field ${extraClass}`.trim()}>
                <div className="result-identity-field-label">
                    <p style={{width: "100%", color: "var(--blue)"}}>{label}</p>
                </div>
                <hr style={{
                    border: "none",
                    background: "#c1c1c1",
                    height: "2px",
                    margin: 0,
                }}/>
                <div className="result-identity-field-value">
                    <p style={{width: "100%"}}>{value}</p>
                </div>
            </div>
        );
    }

    componentDidMount = () => {
        const {student, counter} = this.props;
        this.setState({student, counter});
    };

    render() {
        const {student, counter} = this.props;

        return (
            <div className="result-student-header" style={{
                height: "120px",
                display: "flex",
                flexDirection: "row",
                gap: "5px",
            }}
            >
                <div className="result-student-number" style={{
                    width: "60px",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                    flexShrink: 0,
                }}>
                    <div className="white-background-with-border" style={{
                        height: "50%",
                        width: "100%",
                        display: "flex",
                        placeItems: "center center",
                        textAlign: "center"
                    }}>
                        <p style={{width: "100%", color: "var(--blue)"}}>شماره</p>
                    </div>
                    <div className="white-background-with-border" style={{
                        height: "50%",
                        width: "100%",
                        display: "flex",
                        placeItems: "center center",
                        textAlign: "center"
                    }}>
                        <p style={{width: "100%"}}>{counter}</p>
                    </div>
                </div>
                <div className="white-background-with-border student-photo">
                    <Img src={student?.student_photo} border={false}/>
                </div>

                <div className="white-background-with-border result-identity-card" style={{
                    height: "100%",
                    flex: "1",
                    minWidth: 0,
                }}>
                    <div style={{
                        height: "100%",
                        width: "100%",
                        display: "grid",
                        gridTemplateRows: "35% 1px 65%",
                        textAlign: "center",
                        minWidth: 0,
                    }}>
                        <div style={{
                            display: "flex",
                            placeItems: "center center"
                        }}>
                            <p style={{width: "100%", color: "var(--blue)"}}>شهرت</p>
                        </div>

                        <hr style={{
                            border: "none",
                            background: "#c1c1c1",
                            height: "2px",
                            margin: 0,
                        }}/>

                        <div className="result-identity-fields">
                            {this.renderIdentityField("کد دانشجو", student?.aria_id, "result-identity-id")}
                            {this.renderIdentityField("نام", student?.student_name)}
                            {this.renderIdentityField("تخلص", student?.student_lastname)}
                            {this.renderIdentityField("نام پدر", student?.student_father_name, "result-identity-father")}
                        </div>
                    </div>
                </div>


                {this.renderWidget("مجموعه کریدیت", student?.subjects_summary?.credits)}
                {this.renderWidget("مجموعه نمرات", student?.subjects_summary?.total)}
                {this.renderWidget("فیصدی نمرات", student?.subjects_summary?.percentage)}
                {this.renderWidget("درجه", student?.subjects_summary?.rank)}
                {this.renderWidget("نتیجه", student?.subjects_summary?.result)}
                {this.renderWidget("ملاحظه", student?.subjects_summary?.remark)}
            </div>
        );
    }
}

export default ResultStudentInfoHeader;
